module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img73.668f67bd.jpg";